module.exports = require('./lib');



//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/index.js
// module id = 1
// module chunks = 25